import Vue from 'vue'
import App from './App.vue'
import router from './router';
import { apiUrl } from "./assets/lib/BaseUrl";
import utils from './assets/lib/utils'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
// eslint-disable-next-line no-unused-vars
import $ from 'jquery';

import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import "./assets/icon/iconfont.css"; 


console.log('apiUrl',apiUrl);

Vue.prototype.BASEURL = apiUrl
Vue.prototype.IMGURL = apiUrl
Vue.config.productionTip = false
Vue.prototype.$http = axios
axios.defaults.withCredentials = true;

Vue.use(ElementUI);
Vue.use(utils)
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
// 设置路径

